import { useContext } from 'react'

const generateContextHook = (ctx) => () => {
  return useContext(ctx)
}

export default generateContextHook
